import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import configurations from 'config';
import axios from "axios";
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const ImageUrlPopup = (props) => {
  const { imageFrom, urlPopup, selectedRow, productId, setUrlPopup, mediaList, setMediaList, setSelectedRow, register, watch, control, setValue, getValues, setError, 
    trigger, errors,  setIsLoading 
  
  } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const baseUrl = configurations.baseUrl;
  const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
  const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;

  const handleMediaUrlClose=()=>{ setUrlPopup(false)}

  const handleAddFile = async (e, imageFrom, variant = '') => {
    const isValid = await trigger(`mediaUrl-${imageFrom}`);
    if (isValid) {
      let mediaUrl = getValues(`mediaUrl-${imageFrom}`);
      const fileData = { id: productId, mediaSource: 'url', url: mediaUrl, dataFrom: imageFrom, variantId: variant };

      setIsLoading(true);
      axios.post(baseUrl + '/product/addMedia', fileData, {
        headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey }
      }).then((response) => {
        setIsLoading(false);

        if (response.status == 200) {
          const status = response.data.status;
          const message = response.data.message;
          if (status == 1) {
            let mList = [...mediaList];
            let mediaData = { mediaURL: response.data.data.mediaURL, position: response.data.data.position, mediaType: response.data.data.mediaType, id: response.data.data.azureImageId }
            mList.push(mediaData);
            if (imageFrom == 'product' || imageFrom == 'service')
              setMediaList(mList);
            else {
              selectedRow.imageInfo = mediaData
              selectedRow.image = response.data.data.mediaURL;
              setSelectedRow(selectedRow);
            }
            setValue(`mediaUrl-${imageFrom}`,'');
          }
          else {
            if (message != '')
              toast.error(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
            if (response && response.data && response.data.errors) {
              const errorData = response.data.errors;
              errorData.forEach((error) => {
                setError(error.field, {
                  type: 'server',
                  message: t(error.errors[0])
                });
              });
            }
          }
        }
        else {
          toast.error(t('unableToProccessRequest'), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
        }
      }).catch(error => {
        setIsLoading(false);
        handleErrors(error, t, navigate);
      });
      setUrlPopup(false);
    }
  }

  return (
    <Dialog open={urlPopup} onClose={handleMediaUrlClose}>
      <DialogTitle>{t('addFromUrl')}</DialogTitle>
      <DialogContent>
        <Grid item xs={12} md={12} lg={12}>
          <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <MDTypography variant="body1" className="labelStyle">{t('mediaUrlTitle')}</MDTypography>
                <MDInput
                  type="text"
                  name={`mediaUrl-${imageFrom}`}
                  {...register(`mediaUrl-${imageFrom}`, {
                    required: {
                      value: true,
                      message: t('mediaUrlRequired')
                    },
                    pattern: {
                      value: /^(ftp|http|https):\/\/[^ "]+$/,
                      message: t('invalidMediaUrlFormat')
                    }
                  })}
                  InputProps={{
                    classes: { root: "inputBoxStyle" },
                  }}
                  onChange={(e) => { e.stopPropagation(); }}
                  placeholder={t('https')}
                  fullWidth
                />
                {errors[`mediaUrl-${imageFrom}`] && (
                  <span className="errorMsg FloatRight">{errors[`mediaUrl-${imageFrom}`].message}</span>
                )}
              </Grid>
              <Grid item xs={12}>
                <DialogActions>
                  <MDButton disableRipple onClick={handleMediaUrlClose}>{t('cancel')}</MDButton>
                  <MDButton disableRipple variant="contained" color="primary" onClick={(e) => { handleAddFile(e, imageFrom, imageFrom === 'product' ? (selectedRow ? selectedRow.variantId ? selectedRow.variantId : '' : '') : '') }}>{t('addUrlFile')}</MDButton>
                </DialogActions>
              </Grid>
            </Grid>
          </MDBox>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default ImageUrlPopup;
